import { render } from "./BillingView.vue?vue&type=template&id=4ed55339"
import script from "./BillingView.vue?vue&type=script&lang=js"
export * from "./BillingView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__